import { Controller } from '@hotwired/stimulus'

// Recomputes the remaining meters of a patch as the user types the meters to subtract.
export default class extends Controller {
  static targets = ['input', 'total']
  static values = { available: Number }

  update() {
    const subtracted = parseFloat(this.inputTarget.value) || 0
    const remaining = this.availableValue - subtracted

    this.totalTarget.textContent = this.#numberWithPrecision(remaining)
    this.inputTarget.parentElement.classList.toggle('invalid', remaining < 0)
  }

  #numberWithPrecision(number) {
    const locale = document.documentElement.lang

    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(number)
  }
}